export default "__VITE_ASSET__CC_711L8__"